import React from 'react';
import styles from './Dashboard.module.scss';

export function SystemCard({ system, onClick }) {
  const { name, icon: IconImg, tags = [], description, recommendationText } = system;

  return (
    <button type="button" className={styles.systemCard} onClick={() => onClick?.(system)}>
      <div className={styles.systemCardTop}>
        <div className={styles.systemCardIconWrap}>
          {typeof IconImg === 'string' ? (
            <img src={IconImg} alt="" className={styles.systemCardIconImg} />
          ) : IconImg ? (
            <IconImg className={styles.systemCardIconLucide} size={22} />
          ) : null}
        </div>
        <div className={styles.systemCardTags}>
          {tags.map((t) => {
            const variant = t.variant || 'ok';
            const tagClass =
              variant === 'warn' ? styles.tagWarn : variant === 'neutral' ? styles.tagNeutral : styles.tagOk;
            return (
              <span key={t.label} className={`${styles.systemTag} ${tagClass}`}>
                {t.label}
              </span>
            );
          })}
        </div>
      </div>
      <h4 className={styles.systemCardName}>{name}</h4>
      <p className={styles.systemCardDesc}>{description}</p>
      <p className={styles.systemCardImpact}>{recommendationText}</p>
    </button>
  );
}
